import React, { useCallback } from 'react';

import PlusIcon from 'mdi-react/PlusIcon';
import MinusIcon from 'mdi-react/MinusIcon';
import { Item } from '../sharedTypes';

import { trackListItemChangingQuantity } from '../../tracking';

import * as S from './styles';

type QuantityControlsProps = {
  item: Item;
  updateQuantity: (id: number, quantity: number) => void;
};

const QuantityControls = ({ item, updateQuantity }: QuantityControlsProps) => {
  const increaseQuantity = useCallback(
    (e: React.MouseEvent) => {
      if (item.__typename !== 'ListProduct') return;

      e.preventDefault();
      e.stopPropagation();
      trackListItemChangingQuantity('increase');
      updateQuantity(item.id, item.quantity + 1);
    },
    [item, updateQuantity]
  );

  const decreaseQuantity = useCallback(
    (e: React.MouseEvent) => {
      if (item.__typename !== 'ListProduct') return;

      e.preventDefault();
      e.stopPropagation();
      trackListItemChangingQuantity('decrease');
      updateQuantity(item.id, item.quantity - 1);
    },
    [item, updateQuantity]
  );

  return item.__typename === 'ListProduct' && item.quantity >= 0 ? (
    <S.QuantityControls>
      <S.QuantityButton
        variant="icon"
        size="small"
        color="secondary"
        disabled={item.quantity <= 0}
        onClick={decreaseQuantity}
        icon={<MinusIcon size={20} />}
      />

      <S.QuantityButton
        variant="icon"
        size="small"
        color="secondary"
        onClick={increaseQuantity}
        icon={<PlusIcon size={20} />}
      />
    </S.QuantityControls>
  ) : null;
};

export default QuantityControls;
